export default {

  state: {
    center: null,
    zoom: null,
    clickedPoint: null,
    identifyPoint: null,
    // selectedService: null,
  },

  getters: {

    selectedService(state, getters, rootState, rootGetters) {
      if (rootGetters.serviceAreas.length && rootState.route.query.service && !isNaN(rootState.route.query.service)) {
        return rootGetters.serviceAreas.find(item => item.id === Number(rootState.route.query.service));
      }
      return null;
    },

  },

  mutations: {

    SET_MAP_CENTER(state, payload) {
      state.center = payload;
    },

    SET_MAP_ZOOM(state, payload) {
      state.zoom = payload;
    },

    SET_IDENTIFY_POINT(state, payload) {
      state.identifyPoint = payload;
    },

    SET_SELECTED_SERVICE(state, payload) {
      state.selectedService = payload;
    },

  },

  actions: {

    selectServiceById({ commit, rootState }, id) {
      if (id) {
        const service = rootState.data.serviceAreas.find(item => item.id === Number(id));
        commit('SET_SELECTED_SERVICE', service);
      }
    },

    // selectService({ commit }, feature) {
    //   commit('SET_SELECTED_SERVICE', feature);
    // },

    identifyPoint({ commit }, { latlng = null }) {
      commit('SET_IDENTIFY_POINT', latlng);
    },

    setMapExtent({ commit }, { center, zoom }) {
      commit('SET_MAP_CENTER', center);
      commit('SET_MAP_ZOOM', zoom);
    },

  },

};
